import { Link } from 'react-router';
import { useUnreadNotifications } from '../../lib/use-notifications';

type Props = {
  role: 'customer' | 'professional';
};

/**
 * Header bell with unread-count badge. Wraps a Link so the whole
 * affordance is one tap. Hidden visually for screen readers when
 * unread is zero so the badge isn't announced as "0".
 *
 * Polls every 60s (see useUnreadNotifications) and refreshes when the
 * tab becomes visible — good enough until we wire a websocket / FCM
 * foreground listener.
 */
export function NotificationBell({ role }: Props) {
  const { count } = useUnreadNotifications(role);
  const to = role === 'professional' ? '/professional/inbox' : '/inbox';
  const displayCount = count > 99 ? '99+' : String(count);

  return (
    <Link
      to={to}
      aria-label={
        count > 0
          ? `Notifications, ${count} unread`
          : 'Notifications'
      }
      className="relative inline-flex items-center justify-center w-10 h-10 rounded-full border border-[#eee] bg-white hover:bg-[#fafaf7] transition-colors"
    >
      <span className="material-icons text-[#3a3335] text-[22px]">
        notifications
      </span>
      {count > 0 ? (
        <span
          aria-hidden={count === 0}
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#8e2a2f] text-white text-[10px] font-bold leading-[18px] text-center flex items-center justify-center"
        >
          {displayCount}
        </span>
      ) : null}
    </Link>
  );
}
